import Vue from 'vue';
import App from './App.vue';

//scss
require('@/assets/scss/common.scss');

//Router
import router from '@/router';

//you-tube
import VueYoutube from 'vue-youtube';
 Vue.use(VueYoutube);

//intersection-observer
window.Vue = require('vue');
require('intersection-observer');

import VueObserveVisibility from 'vue-observe-visibility';
Vue.use(VueObserveVisibility);

 // FontAwesome ~
import { library } from '@fortawesome/fontawesome-svg-core';
import { fas } from '@fortawesome/free-solid-svg-icons';
import { fab } from '@fortawesome/free-brands-svg-icons';
import { far } from '@fortawesome/free-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

library.add(fas, far, fab);

Vue.component('font-awesome-icon', FontAwesomeIcon);
//~ FontAwesome

Vue.config.productionTip = false;

new Vue({
  router: router,
  render: h => h(App),
}).$mount('#app');
